<template>
  <div class="userstate">
    <div class="statebox" v-if="!hasRegistered">
      您还未报名，请点击报名入口报名
    </div>
    <div class="statebox" v-else>
      <div class="statebox" v-if="status == 0">
        您已提交报名，信息正在审核中！
      </div>
      <div class="statebox" v-if="status == 1">
        <p>恭喜您已报名成功，请扫码入群！</p>
        <div>
          <img class="ermBlock" :src="WeChatgroup" alt="" />
        </div>
      </div>
      <div class="statebox" v-if="status == 2">
        审核未通过（<span style="color: #e6a23c">{{ reject_reason }}</span
        >）
      </div>
    </div>
  </div>
</template>

<script>
import { getRegistrationInfo, gettrainings } from "../API/user";

export default {
  components: {},
  props: {},
  data() {
    return {
      status: null,
      signstate: 2,
      hasRegistered: false,
      reject_reason: "",
      WeChatgroup: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getUserState();
    // this.gettrainingsList();
    this.$emit("menuActiveHandle", 1);
  },
  mounted() {},
  methods: {
    // 获取培训列表
    async gettrainingsList() {
      const { data: res } = await gettrainings({ page: 1, limit: 999 });
      if (res.data.list) {
        const list = res.data.list.filter((item) => item.status === 1);
        this.WeChatgroup = list[0].wechat_group_qrcode
          ? list[0].wechat_group_qrcode
          : "https://gyyc-jctxpx.oss-cn-beijing.aliyuncs.com/public-image/WeChat-group.png";
      }

      // const list = res.map
    },
    async getUserState() {
      const { data: res } = await getRegistrationInfo();
      this.hasRegistered = res.data.hasRegistered;
      if (this.hasRegistered) {
        this.status = res.data.data?.status;
        this.reject_reason = res.data.data?.reject_reason;
        this.WeChatgroup = res.data.data?.wechat_group_qrcode
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.userstate {
  width: 100%;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  .statebox {
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    
    .ermBlock {
      width: 300px;
    }
    .el-link {
      font-size: 20px;
    }
    p {
      padding-top: 20px;
    }
  }
}
</style>
